module.exports = __webpack_public_path__ + "media/material-kit/img/arrow-right-b05075115da474772b1bf12b3b4e122f.png";